import React, { useState } from 'react'
import { Drawer, DrawerHeader, Spinner, Button } from '@sainsburys-tech/bolt'

import * as Styled from './OrderSwatchDrawer.styles'
import { pushEventAndTrack } from '../../../helpers/taggingSerializer'

const BRAND = process.env.BRAND || 'ARGOS'

const OrderSwatchDrawer = ({ showSwatch }) => {
  if (!showSwatch) return null

  const [showDrawer, toggleShowDrawer] = useState(false)
  const [hasIFrameLoaded, setIFrameLoaded] = useState(false)

  return (
    <Styled.OrderSwatch data-test='mto-order-swatch' className='top-border' role='link' tabIndex='0'>
      <Styled.OrderSwatchIcon />
      <Button
        kind='link'
        onClick={() => {
          toggleShowDrawer(true)
          pushEventAndTrack({ eventInfo: { eventName: 'pdp_mtoCtaClick', eventAction: 'Order fabric samples' } })
        }}
        data-test='order-swatch-link'
      >
        Order up to 5 free fabric samples
      </Button>

      <Drawer
        show={showDrawer}
        size='full'
        onClose={() => {
          toggleShowDrawer(false)
        }}
      >
        <DrawerHeader>Order free fabric samples</DrawerHeader>
        <Styled.SpinnerWrapper show={!hasIFrameLoaded}>
          <Spinner size={100} />
        </Styled.SpinnerWrapper>

        <Styled.IframeContainer show={hasIFrameLoaded}>
          <iframe
            name='mto-swatchIframe'
            id='mto-swatchIframe'
            src={`/sofa_swatchmto?brand=${BRAND.toLowerCase()}&source=web&sku=-1`}
            title='Order Swatch'
            onLoad={() => setIFrameLoaded(true)}
            data-test='order-swatch-iframe'
          />
        </Styled.IframeContainer>
      </Drawer>
    </Styled.OrderSwatch>
  )
}

export default OrderSwatchDrawer
